export default __webpack_public_path__ + "static/media/slide1.4c9f01e7.jpg";